import { render, staticRenderFns } from "./ImpressumPage.vue?vue&type=template&id=3b073954&scoped=true&"
import script from "./ImpressumPage.vue?vue&type=script&lang=js&"
export * from "./ImpressumPage.vue?vue&type=script&lang=js&"
import style0 from "./ImpressumPage.vue?vue&type=style&index=0&id=3b073954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b073954",
  null
  
)

export default component.exports